export const CAMPAIGN_ID_MAX_LENGTH = 48;

export const CAMPAIGN_ID_PATTERN = /^[a-z0-9](?:[a-z0-9_-]{0,47})$/u;

export function normalizeCampaignId(value: unknown): string | null {
  if (value === undefined || value === null || value === "") return null;
  if (typeof value !== "string" || !CAMPAIGN_ID_PATTERN.test(value)) {
    throw new Error(`Campaign identifier must be 1-${CAMPAIGN_ID_MAX_LENGTH} lowercase letters, numbers, underscores or hyphens.`);
  }
  return value;
}

export function campaignIdFromSearch(search: string): string | null {
  const values = new URLSearchParams(search).getAll("c");
  if (values.length === 0) return null;
  if (values.length !== 1) return null;
  try {
    return normalizeCampaignId(values[0]);
  } catch {
    return null;
  }
}
